import ButtonSelection from '@/views/components/ButtonSelection/ButtonSelection.vue';
import { GateConfigDTO } from '@/../client-generator/generated-clients/plants';
import { Vue, Options } from 'vue-class-component';

@Options({
  name: 'GateConfigComponent',
  components: {
      ButtonSelection,
    },
  props: {
    gatesToConfigure: {
      required: true,
      type: Object as () => { [key: string]: GateConfigDTO },
    },
    availableScsAddressGate: {
      required: true,
      type: Array as () => number[],
    }
  },
  watch: {
    gatesToConfigure: {
      handler() {
        this.updateButtonStates();
        this.verifyValidityOfScsAddresses();
      },
      deep: true
    }
  },
  emits: ["anyScsError"],
})
export default class GateConfigComponent extends Vue {
  gatesToConfigure!: { [key: string]: GateConfigDTO };
  availableScsAddressGate!: number[];
  anyScsError!: boolean;
  readonly MIN_SCS_ADDRESS = 0;
  readonly MAX_SCS_ADDRESS = 95;
  scsAddrNotValid: boolean[] = [];
  invalidScsReason: string[] = [];

  newPeDisabled: boolean[] = [];
  keypadDisabled: boolean[] = [];
  smartReaderDisabled: boolean[] = [];

  verifyValidityOfScsAddresses() {
    // Raccogli tutti gli indirizzi SCS già usati nei gate configurati
    const usedAddresses = Object.values(this.gatesToConfigure)
      .map((gate: GateConfigDTO) => gate.scsAddress!)
      .filter((addr: number | undefined) => addr !== undefined && addr !== null)
      .map((addr: number) => Number(addr));

    Object.values(this.gatesToConfigure).forEach((gate: GateConfigDTO, index: number) => {
      if (gate.scsAddress === undefined || gate.scsAddress === null) {
        this.scsAddrNotValid[index] = false;
        this.invalidScsReason[index] = '';
        return;
      }
      
      const value = Number(gate.scsAddress);
      const acceptedRange = value >= this.MIN_SCS_ADDRESS && value <= this.MAX_SCS_ADDRESS;
      
      // Verifica se è disponibile nella lista del plant
      const availableInPlant = this.availableScsAddressGate.includes(value) ?? false;
      
      // Verifica se è usato da altri gate (escludendo se stesso)
      const usedByOtherGate = usedAddresses.filter((addr: number) => addr === value).length > 1;
      
      this.scsAddrNotValid[index] = !acceptedRange || !availableInPlant || usedByOtherGate;
      
      if (!acceptedRange) {
        this.invalidScsReason[index] = this.$t('AppResourceEP.GateScsAddressOutOfRange');
      } else if (!availableInPlant) {
        this.invalidScsReason[index] = this.$t('AppResourceEP.ScsAddressAlreadyInUse');
      } else if (usedByOtherGate) {
        this.invalidScsReason[index] = this.$t('AppResourceEP.ScsAddressAlreadyInUse');
      } else {
        this.invalidScsReason[index] = '';
      }
    });

    this.anyScsError = this.scsAddrNotValid.some(error => error === true);
    this.$emit("anyScsError", this.anyScsError);
  }

  updateButtonStates() {
    Object.values(this.gatesToConfigure).forEach((gate: GateConfigDTO, index: number) => {
      // Se newPe è selezionato, disabilita smartReader
      // Se keypad è selezionato, disabilita smartReader
      // Se smartReader è selezionato, disabilita newPe e keypad
      
      if (gate.smartReaderSelected) {
        this.newPeDisabled[index] = true;
        this.keypadDisabled[index] = true;
      } else {
        this.newPeDisabled[index] = false;
        this.keypadDisabled[index] = false;
      }
      
      if (gate.newPeSelected || gate.keypadSelected) {
        this.smartReaderDisabled[index] = true;
      } else {
        this.smartReaderDisabled[index] = false;
      }
    });
  }
}
